import VrPlayer from './VrPlayer';
export default VrPlayer;



/** WEBPACK FOOTER **
 ** ./source/index.js
 **/